import { ToggleButtonGroup } from "@mui/material"
import { styled } from "@mui/system"
import PropTypes from "prop-types"
import React from "react"

const StyledToggleGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  marginRight: theme.spacing(2),
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: "999px",
  "& .MuiToggleButton-root": {
    textTransform: "none",
    fontWeight: 500,
    borderRadius: "999px",
    border: "none",
    padding: theme.spacing(1, 3),
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    marginRight: 0,
    marginBottom: theme.spacing(2),
  },
}))

const ToggleGroup = ({ children, ...props }) => {
  return <StyledToggleGroup {...props}>{children}</StyledToggleGroup>
}

ToggleGroup.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.any,
  exclusive: PropTypes.bool,
  onChange: PropTypes.func,
  "aria-label": PropTypes.string,
}

export default React.memo(ToggleGroup)
